import { render, staticRenderFns } from "./FreelancerLogo.vue?vue&type=template&id=49db7ce6"
import script from "./FreelancerLogo.vue?vue&type=script&lang=ts"
export * from "./FreelancerLogo.vue?vue&type=script&lang=ts"
import style0 from "./FreelancerLogo.vue?vue&type=style&index=0&id=49db7ce6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports